// Bakery-themed team identities used by both the launch UI (default names the
// host can edit) and the Room Durable Object (fallback when none are supplied).
import type { TeamConfig } from "./types";

export const MIN_TEAMS = 2;
export const MAX_TEAMS = 8;
export const DEFAULT_TEAMS = 4;

/** Emoji + default name per team slot, in assignment order. */
export const TEAM_THEMES: { emoji: string; name: string }[] = [
  { emoji: "🥐", name: "The Croissants" },
  { emoji: "🍞", name: "Sourdough Squad" },
  { emoji: "🧁", name: "The Cupcakes" },
  { emoji: "🥖", name: "Baguette Bunch" },
  { emoji: "🍩", name: "Doughnut Crew" },
  { emoji: "🥨", name: "Pretzel Posse" },
  { emoji: "🍪", name: "Cookie Club" },
  { emoji: "🎂", name: "Layer Cakers" },
];

// Mirrors the Room's avatar palette so the launch UI can preview team colours.
export const TEAM_COLORS = [
  "var(--red)",
  "var(--gold)",
  "var(--ans-c)",
  "var(--ans-d)",
  "var(--caramel)",
  "var(--crust)",
  "var(--ans-b)",
  "var(--red-bright)",
];

/** Clamp a requested team count into the supported range. */
export function clampTeamCount(n: number): number {
  if (!Number.isFinite(n)) return DEFAULT_TEAMS;
  return Math.max(MIN_TEAMS, Math.min(MAX_TEAMS, Math.round(n)));
}

/** Build the default team list for a given count (host may then rename). */
export function defaultTeams(count: number): TeamConfig[] {
  const n = clampTeamCount(count);
  return Array.from({ length: n }, (_, i) => ({
    id: `t${i}`,
    name: TEAM_THEMES[i].name,
    emoji: TEAM_THEMES[i].emoji,
    color: TEAM_COLORS[i % TEAM_COLORS.length],
  }));
}
